import { createBrowserRouter } from "react-router-dom";

import { createRouterObservers } from "@honeycomb/mystique";

import { routes } from "./routes";

export const router = createBrowserRouter([routes()]);

createRouterObservers(router);
